import { chain } from 'lodash';

export default {
  cachedRecentGeolocation: (state) => {
    if (chain(state.latestGeolocation).get('timestamp').isDate().value()) {
      const minutesSince = (Date.now() - state.latestGeolocation.timestamp) / 1000 / 60;
      if (minutesSince < 2) {
        // Only return geolocation if it's less than 2 minutes old. Otherwise, it
        // needs to be refreshed
        return state.latestGeolocation;
      }
    }
    return null;
  }, // cachedRecentGeolocation
};
